module.exports = __webpack_public_path__ + "img/shoucang.bfaea83f.png";